"use strict";

import React from 'react/addons';
import ClassNameMixin from 'ofs/utils/ClassNameMixin';
import SetIntervalMixin from 'ofs/utils/SetIntervalMixin';

var PureRenderMixin = React.addons.PureRenderMixin;

function noop() {}


var ProgressButton = React.createClass({
  mixins: [PureRenderMixin, ClassNameMixin, SetIntervalMixin],

  propTypes: {
    'children': React.PropTypes.string.isRequired,
    'saving': React.PropTypes.bool.isRequired,
    'finished': React.PropTypes.bool.isRequired,
    'size': React.PropTypes.string,
    'onClick': React.PropTypes.func
  },

  getDefaultProps: function() {
    return {
      'onClick': noop
    };
  },

  getInitialState: function() {
    return {
      'progress': 0
    };
  },

  componentWillReceiveProps: function(nextProps) {
    if (nextProps.finished === true && this.props.finished === false) {
      // finished loading
      this.clearIntervals();
      this.setState({
        'progress': 1
      });
    }

    if (nextProps.saving === true && this.props.saving === false) {
      // start progress bar
      this.setInterval(this.progressTick, 200);
    }
  },

  progressTick: function() {
    var {progress} = this.state;

    var newProgress = Math.min(progress + Math.random() * 0.1, 1);

    // don't ever reach 1
    if (newProgress < 1) {
      this.setState({
        'progress': newProgress
      });
    }
  },

  render: function() {
    var buttonClasses = {
      'ofs-Button': true,
      'ofs-ProgressButton': true,
      'ofs-ProgressButton--saving': this.state.saving
    };

    if (this.props.size) {
      buttonClasses['ofs-Button--' + this.props.size] = true;
    }

    var progressBarWidth = (this.state.progress * 100) + '%';

    return (
      <button className={this.getClassSet(buttonClasses)}
        onClick={this.props.onClick}
        disabled={this.props.disabled}
        >
        <span className="ofs-ProgressButton__Content">{this.props.children}</span>
        <span className="ofs-ProgressButton__ProgressBar" style={{'width': progressBarWidth}}></span>
      </button>
    );
  }
});

export default ProgressButton;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/common/ProgressButton.jsx
 **/